export default "__VITE_ASSET__Ci4Y$34g__"